import { showAlertMessage, showNoticeMessage } from 'javascripts/messages';
import { modelTerminology } from 'javascripts/terminology';
import RecordAction from '../RecordAction';
import { Page } from 'components/framework/models';
import type ApplicationModel from 'components/framework/ApplicationModel';

export class CopyLinkAction extends RecordAction {
  get title() {
    const record = this.selectedRecords[0];
    const recordType = modelTerminology(record).toLowerCase();

    return `Copy link to ${recordType}`;
  }

  get icon() {
    return 'fa-regular fa-paperclip';
  }

  showForRecord(record: ApplicationModel): record is ApplicationModel {
    return !!(
      'path' in record &&
      record.path &&
      this.selectedRecords?.length === 1 &&
      !('isLink' in record && record.isLink)
    );
  }

  async runForRecords(records) {
    let recordPath = location.origin + records[0].path;

    if (records[0].documentType === Page.DOCUMENT_TYPE_EXTERNAL_LINK) {
      recordPath = records[0].externalUrl;
    }

    try {
      await navigator.clipboard.writeText(recordPath);
      showNoticeMessage('Record link copied to clipboard');
    } catch (e) {
      showAlertMessage('Record link could not be copied to clipboard');
    }
  }
}
